import * as S from "./taskCardContentsFirstSteps.styles";
import { ReactComponent as IconGPS } from "../../../../styles/assets/svg/icon-gps.svg";
import { ReactComponent as IconLeft } from "../../../../styles/assets/svg/icon-left-arrow.svg";
import { ReactComponent as IconRight } from "../../../../styles/assets/svg/icon-right-arrow.svg";
import {
  Transportation,
  TransportationType,
} from "../../../../interface/transportation";
import { ReactComponent as IconCameraWhite } from "../../../../styles/assets/svg/icon-camera-white.svg";
import dayjs from "dayjs";

export interface TaskCardContentStepsProps {
  setIsNextLevel: React.Dispatch<React.SetStateAction<number>>;
  loadingPointData?: TransportationType;
  isLoading?: boolean;
  handleNextButtonClick: () => void;
  onImageRegisterPageMove: () => void;
  maxStep?: number;
}

export const TaskCardContentsFirstSteps = ({
  loadingPointData,
  handleNextButtonClick,
  onImageRegisterPageMove,
  maxStep = 6,
}: TaskCardContentStepsProps) => {
  return (
    <S.TaskBox>
      <S.TaskTotalWrap onClick={onImageRegisterPageMove}>
        <IconCameraWhite width={25} height={25} /> 사진등록
      </S.TaskTotalWrap>

      <S.TaskContainer>
        <S.TaskContent>
          <S.TaskHeadBox>
            <S.Sbox>
              <S.StepBox>1 / {maxStep}단계</S.StepBox>
              <S.StateBox>상차지 이동</S.StateBox>
            </S.Sbox>
            <S.DateBox>
              {dayjs(new Date()).format("YYYY-MM-DD HH:mm")}
            </S.DateBox>
          </S.TaskHeadBox>

          <S.ProgressBar progress="21%" />

          <S.LocationBox>
            <IconGPS />
            <S.AreaBox>
              {loadingPointData?.load_place_name}
              <span>{loadingPointData?.load_place_address}</span>
            </S.AreaBox>
          </S.LocationBox>

          <S.DetailContents>
            <S.ContainerBox>
              <S.TableHeader>컨테이너 규격</S.TableHeader>
              <S.TableCell>{loadingPointData?.container_spec}</S.TableCell>
            </S.ContainerBox>
            <S.ContainerBox>
              <S.TableHeader>컨테이너 번호</S.TableHeader>
              <S.TableCell>{loadingPointData?.container_no}</S.TableCell>
            </S.ContainerBox>
          </S.DetailContents>
        </S.TaskContent>

        <S.ButtonBox>
          <S.Button
            width="100%"
            color="primary"
            isErrorCheck={true}
            onClick={handleNextButtonClick}
          >
            <S.BText>다음</S.BText>
            <IconRight width={20} height={20} />
          </S.Button>
        </S.ButtonBox>
      </S.TaskContainer>
    </S.TaskBox>
  );
};
export default TaskCardContentsFirstSteps;
